//imports
import { all } from 'redux-saga/effects';

//Views
import deviceInfoSagas from 'Modules/.common/.components/vidfleetInformation/redux/saga';
import entityTagPickerSagas from 'Modules/.common/.components/EntityTagPicker/redux/saga';
import tagPickerSagas from 'Modules/.common/.components/TagPicker/redux/saga';
import resetPasswordSagas from 'Modules/.common/.components/resetPassword/redux/saga';
import resetEmailSagas from 'Modules/.common/.components/resetEmail/redux/saga';
import resendInviteSagas from 'Modules/.common/.components/resendInvite/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        deviceInfoSagas(),
        entityTagPickerSagas(),
        tagPickerSagas(),
        resetPasswordSagas(),
        resetEmailSagas(),
        resendInviteSagas(),
    ]);
}